import { render } from "./PaymentModal.vue?vue&type=template&id=1a0789b2&scoped=true"
import script from "./PaymentModal.vue?vue&type=script&lang=js"
export * from "./PaymentModal.vue?vue&type=script&lang=js"

import "./PaymentModal.vue?vue&type=style&index=0&id=1a0789b2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a0789b2"]])

export default __exports__